import { useAuthStore } from "@/stores/AuthStore";

export default function userHasPermission(permissionName) {

    const authStore = useAuthStore();
    const me = authStore.me;

    return (me?.permissions.filter(permission => permission.name === permissionName).length > 0);
};